import React, { Component } from 'react';

import '../statics/css/privace-policy.css';

import Logo from '../statics/images/logo_default_white.png'
import iconTreino from '../statics/images/dumbell.svg'
import { Image, Button } from 'react-bootstrap';
import { Glyphicon } from 'react-bootstrap';

import If from "../utils/If"

import '../statics/css/online-consult.css'
import profissionalPhoto from '../statics/images/profissional_photo.png'
import logoDefault from '../statics/images/logo_default.png'

class OnlineConsult extends Component {

  constructor(props) {
    super(props);

    this.state = {

    };

  }

  componentWillMount() {
    //this.props.history.push('/login');
  }

  openPagSeguro() {
    window.open("https://pag.ae/7V44Y-MX7");
  }

  render() {

    return (
      <div className="online-consult-page">

        <Image src={logoDefault} responsive className="img-w-100 logo" />

        <Image src={profissionalPhoto} responsive className="img-w-100" />

        <div className="text-div">
          <p className="fontx2"><strong><span className="color-primary">Olá!</span> Tudo bem com você?</strong></p>
          <p>Inicialmente, deixe que eu me apresente!</p>
          <p>Meu nome é <strong>Lucas Nascimento</strong>, sou personal trainer e consultor esportivo com mais de 12mil horas/aula de
atuação na sala de musculação, também sou graduando em nutrição.</p>
          <p>Imagino que você esteja aqui buscando <strong>RESULTADOS</strong> diferentes, pois já se cansou de treinar e
não conseguir alcançar os <strong>OBJETIVOS</strong> que muito deseja. Estou certo?</p>
          <p>Posso ser sincero com você? Não vai adiantar ir à academia regularmente, mesmo com força de
vontade e disciplina, se o seu plano de treino não estiver adequado as suas necessidades.</p>
          <p>Você precisa de uma estratégia elaborada especificamente para você e é exatamente isso que a&nbsp;
<u><strong><span className="color-primary">LN</span> Consultoria</strong></u> em fitness faz. Ela é toda planejada e elaborada de acordo com os seus objetivos.</p>
          <p>O plano é elaborado com base na sua rotina, assim, o seu <strong>OBJETIVO</strong> ficará completamente ao seu
alcance. Nada de um plano impossível e complexo de seguir, pelo contrário, <strong>IREI DIRETO AO
PONTO</strong>.</p>
          <p>Primeiramente é feita uma análise das suas individualidades e necessidades e o plano elaborado
estará perfeitamente ao seu alcance. Meu objetivo é prescrever um treino EXCLUSIVO para você e,
assim, te apresentar um <strong>MEIO</strong> de alcançar resultados <strong>REAIS</strong>.</p>
          <p>Então, vamos juntos nessa?</p>
          <p>Agora, para que a consultoria possa te ajudar a alcançar o seu objetivo eu preciso que você assuma
um compromisso comigo:</p>
          <p className="fontx2"><strong>Passo 1</strong> - Tenha força de vontade</p>
          <p className="fontx2"><strong>Passo 2</strong> - Siga minhas orientações</p>
          <p className="fontx2"><strong>Passo 3</strong> - E lembre-se, você não precisa estar motivado todos os dias. <strong>BASTA APENAS QUE
TENHA DISCIPLINA!</strong></p>

          <br />
          <Button onClick={() => this.openPagSeguro()}
            bsStyle="success" className="btn-begin-consult">Iniciar Consultoria</Button>
        </div>

      </div>
    );
  }
}

export default OnlineConsult;



// WEBPACK FOOTER //
// src/components/online-consult.js